import {Component, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import {fromEvent} from 'rxjs';
import {debounceTime, distinctUntilChanged, map} from 'rxjs/operators';

import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'app-common-element',
  templateUrl: './common-element.component.html',
  styleUrls: ['./common-element.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CommonInputComponent),
      multi: true
    }
  ]
})
export class CommonInputComponent implements OnInit, ControlValueAccessor {
  @Input() objectProperties: any[];
  @Input() objectToSet: any[];
  @Input() elementName: string;
  @Input() label: string;
  @Input() isFirst: boolean;
  @Input() required: boolean;
  @Input() formObject;
  @Input() invalidInput: boolean;
  @Input() isInfo: boolean;
  @Input() isDisabled: boolean;
  @Input() errorMessage: string;

  /**
   * SK/EN data inputs translation support
   */
  /** flag to determine, whether is translation support for input ON */
  @Input() isTranslated = false;
  /** currently selected language of the input */
  @Input() selectedInputLanguage: 'SK' | 'EN' = 'SK';
  /** EN JSON model property/ies, where the english data will be saved */
  @Input() objectPropertiesEn: any[];


  @Output() formChanged = new EventEmitter();
  @Output() inputChanged = new EventEmitter();
  protected actualValue: any;
  
  private onChange: any = () => {};
  private onTouched: any = () => {};

  constructor() {
  }

  public get ngModelObject(): any {
    return this.getObjectProperty();
  }

  public set ngModelObject(value) {
    this.actualValue = value;
    this.setObjectProperty(value);
    this.onChange(value);
    this.onTouched();
  }

  ngOnInit(): void {
  }

  public emitChange(inputElement: ElementRef): void {
    fromEvent(inputElement.nativeElement, 'keyup').pipe(
      map((event: any) => {
        return event.target.value;
      })
      , debounceTime(500)
      , distinctUntilChanged()
    ).subscribe((text: string) => {
      this.emitValue();
    }, (err) => {
      console.log('error', err);
    });
  }

  public emitValue(value?: any, setObject?: any): void {
    if (value || value === 0) {
      this.actualValue = value;
    }
    if (setObject) {
      this.setObject(this.actualValue);
    } else if (this.objectProperties) {
      this.setObjectProperty(this.actualValue);
    }
    this.inputChanged.emit(this.actualValue);
    this.formChanged.emit(this.formObject);
  }

  public updateValue(event: any): void {
    this.actualValue = event;
  }

  protected getObjectProperty(): any {
    let result = this.formObject;
    const currentObjectProperty = this.getCurrentObjectProperty();

    for (const objectProperty of currentObjectProperty) {
      if (this.elementName === 'studyAdvisorInput') {
        // ospraveldnujem sa, je to hrozny fix ale inak som z toho nevedel vykroculovat :) \_(- -)_/
        return result?.studyAdvisor?.[objectProperty];
      }
      result = result[objectProperty];
    }
    return result;
  }

  protected setObjectProperty(value: any): void {
    const currentObjectProperty = this.getCurrentObjectProperty();

    switch (currentObjectProperty?.length) {
      case 1:
        this.formObject[currentObjectProperty[0]] = value;
        break;
      case 2:
        this.formObject[currentObjectProperty[0]][currentObjectProperty[1]] = value;
        break;
      case 3:
        this.formObject[currentObjectProperty[0]][currentObjectProperty[1]][currentObjectProperty[2]] = value;
        break;
    }
  }

  protected getObject(): any {
    let result = this.formObject;
    for (const objectProperty of this.objectToSet) {
      result = result[objectProperty];
    }
    return result;
  }

  protected setObject(value: any): void {
    switch (this.objectToSet?.length) {
      case 1:
        this.formObject[this.objectToSet[0]] = value;
        break;
      case 2:
        this.formObject[this.objectToSet[0]][this.objectToSet[1]] = value;
        break;
      case 3:
        this.formObject[this.objectToSet[0]][this.objectToSet[1]][this.objectToSet[2]] = value;
        break;
    }
  }

  /**
   * returns the correct 'objectProperties' array (path to json, where to set the data and so on.)
   *
   * when input is translated, check what lang is selected and choose correct JSON property
   * otherwise, default `objectProperties` variable is returned
   * @private
   */
  private getCurrentObjectProperty(): any[] {
    return (this.isTranslated && this.selectedInputLanguage === 'EN')
      ? this.objectPropertiesEn
      : this.objectProperties;
  }

  writeValue(value: any): void {
    this.actualValue = value;
    this.setObjectProperty(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
}
